<template>
  <div
    class="flex align-items-center gap-2 p-2 border-round cursor-pointer"
    :class="activa ? 'bg-primary-100 border-1 border-primary' : 'surface-hover'"
    @click="$emit('seleccionar')"
  >
    <div
      class="border-round-sm flex-shrink-0"
      :style="`background:${linea.color};width:14px;height:14px;border:1px solid rgba(0,0,0,.15)`"
    />
    <div class="flex-1 min-w-0">
      <div class="font-medium text-sm">Línea {{ linea.numero }}</div>
      <div class="text-xs text-color-secondary">
        {{ linea.ida?.paradas?.length || 0 }} paradas ida ·
        {{ linea.vuelta?.paradas?.length || 0 }} vuelta
      </div>
    </div>
    <Button
      icon="pi pi-trash"
      text
      size="small"
      severity="danger"
      @click.stop="$emit('eliminar')"
    />
  </div>
</template>

<script setup>
defineProps({ linea: Object, activa: Boolean })
defineEmits(['seleccionar', 'eliminar'])
</script>
